import React, {  useState } from "react";
import useSave from "../../Hooks/useSave";
import Modal from "react-awesome-modal";
import Select from "react-select";
import useValidateRole from "../../Hooks/useValidateRole";
import { ColumnDirective, ColumnsDirective,Grid, Resize, GridComponent, Inject, Page, Sort, Filter, Group } from '@syncfusion/ej2-react-grids';
import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
import { Link } from "react-router-dom";
import useDelete from "../../Hooks/useDelete";
import useUpdate from "../../Hooks/useUpdate";
const CapitationCriteria = () => {
    
    const [open, setOpen] = useState(false);
    const [inputs, setInputs] = useState({});
    const url = "api/CapitationCriteria";
    let grid= Grid | null;
    const dataurl = process.env.REACT_APP_BASE_URL + 'api/CapitationCriteria/AllCapitationCriteria';
    const [view, setview] = useState(false);
    const [update, setUpdate] = useState(false);
    const [PageRole, setPageRole] = useState("Capitation Criteria");
    const handleOpenModal = (event) => {
        //event.persist();
        setInputs({});
        setOpen(true);
    }; 
    const CallDeletehook = async () => {
        useDelete(url + "/" + inputs.id);
        grid.refresh();
    };
    const HandelDelete = () => {
        if (inputs.id) {
            CallDeletehook();
        } else {
            alert("Select a record to delete");
        }
    };
    const handleView = () => {
        if (inputs.id) {
            setview(true);
            setUpdate(false);
            setOpen(true);
        } else {
            alert("Select a record to veiw");
        }
    };

   
    const handleEdit = k => {
        if (inputs.id) {
            setview(false);
            setUpdate(true);
            setOpen(true);
        } else {
            alert("Select a record to update");
        }
    };
    const HandleUpdate = (data) => {

        useUpdate(url + "/" + inputs.id, data);
        grid.refresh();
    };
    const HandleSave = (data) => {

        useSave(url, data);
        grid.refresh();

    };
    const HandleSubmit = e => {
        e.preventDefault();
        const data = {
            id: inputs.id,
            dateFrom: inputs.dateFrom,
            code: inputs.code,
            age: inputs.age,
            minCourseDuration: inputs.minCourseDuration,
            minAmtPerYear: inputs.minAmtPerYear,
            maxAmtPerYear: inputs.maxAmtPerYear,
            citizenShip: inputs.citizenShip,
            status: inputs.status,
            kuccps: inputs.kuccps
        };
        if (update) {
            HandleUpdate(data);
        } else {
            HandleSave(data);
        }
    };

    const handleCloseModal = () => {
        setInputs({});
        setOpen(false);
        setview(false);
        setUpdate(false);
    };
    const handleSelect = (k, event) => {         
        setInputs(k.data);
    };
    const handleSelectChange = (UserGroup, actionMeta) => {
        setInputs((inputs) => ({ ...inputs, [actionMeta.name]: UserGroup.value }));
    };
    const handleInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputs((inputs) => ({ ...inputs, [name]: value }));
    }; const ActionsBtn = () => {
        return (
            <div>
                {useValidateRole(PageRole, "Edit") ? (
                    <button
                        className="btn btn-primary p-2"
                        type="button"
                        onClick={handleEdit}
                    >
                        Update
                    </button>
                ) : null}
            &nbsp; &nbsp;
                {useValidateRole(PageRole, "Remove") ? (
                    <button onClick={HandelDelete} className="btn btn-danger p-2">
                        Delete
                    </button>
                ) : null}
            &nbsp;
                <button
                    className="btn btn-warning p-2"
                    type="button"
                    onClick={handleCloseModal}
                >
                    Close
            </button>
            </div>
        );
    };
    const StatusOptions = [{ name: "Active" }, { name: "Not Active" }].map((k, i) => {
        return {
            value: k.name.toString(),
            label: k.name.toString()
        };
    });
    const KUCCPSOptions = [{ name: "Yes" }, { name: "No" }].map((k, i) => {
        return {
            value: k.name.toString(),
            label: k.name.toString()
        };
    });

    const CitizenShipOptions = [{ name: "Kenyan" }, { name: "Foreigner" }].map((k, i) => {
        return {
            value: k.name.toString(),
            label: k.name.toString()
        };
    });
    return (
        <div id="content" className="content">
            <ol class="breadcrumb float-xl-right">
                <li class="breadcrumb-item">
                    {" "}
                    <Link to="/">Home </Link>{" "}
                </li>
                <li class="breadcrumb-item active">Capitation Criteria</li>
            </ol>
            <h1 class="page-header mb-3">Capitation Criteria</h1>
            <div style={{ backgroundColor: "white" }}>
                <div className="row">
                    <div class="col-sm-12 d-flex flex-row float-right">
                        &nbsp; &nbsp; &nbsp;
                  {useValidateRole(PageRole, "AddNew") ? (
                            <button
                                onClick={handleOpenModal}
                                className="btn btn-primary p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp;  New &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "View") ? (
                            <button
                                onClick={handleView}
                                className="btn btn-success p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; View &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "Edit") ? (
                            <button
                                onClick={handleEdit}
                                className="btn btn-info p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; Edit &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "Remove") ? (
                            <button
                                onClick={HandelDelete}
                                className="btn btn-danger p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; Delete &nbsp;
                            </button>
                        ) : null}
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                    <GridComponent ref={g => grid = g}
              allowPaging={true}
              allowResizing={true}
              allowFiltering={true}
              allowTextWrap={true}
              rowSelected={(args) => {
                handleSelect(args);
              }}
              dataSource={new DataManager({
                adaptor: new UrlAdaptor(),
                crossDomain: true,
                url: dataurl,
                headers: [{
                  Authorization: "Bearer " + window.sessionStorage.getItem("xtoken")
                }]
              })
              }>
              <ColumnsDirective>             
                <ColumnDirective field='dateFrom' type='date' format='dd/MM/yyyy' headerText='From Date'  />         
                <ColumnDirective field='minCourseDuration'  headerText='Min Course Duration'  />             
                <ColumnDirective field='minAmtPerYear' type='number' format='n2' headerText='Min Amt Per Year'/>             
                <ColumnDirective field='maxAmtPerYear' type='number' format='n2' headerText='max AmtPerYear' />
                <ColumnDirective field='citizenShip' headerText='citizenShip' />
                <ColumnDirective field='status' headerText='Status' />
                <ColumnDirective field='kuccps' headerText='kuccps' />
                <ColumnDirective field='age' headerText='Max age' />
                
              </ColumnsDirective>
              <Inject services={[Page, Sort, Resize, Filter]} />
            </GridComponent>
                    </div>
                </div>
            </div>

            <Modal visible={open} width="64%" height="69%" effect="fadeInUp">
                <div style={{ "overflow-y": "auto", height: "100%" }}>
                    <a className="close" onClick={() => handleCloseModal()}>
                        &times;
            </a>

                    <div className="row">
                        <div className="col-sm-5"></div>
                        {view ? null : (
                            <div className="col-sm-4 fontWeight-bold text-blue">Capitation Criteria</div>
                        )}
                    </div>
                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="ibox-content">
                                {view ? (
                                    <div>
                                        <h3>Capitation Criteria</h3>
                                        <table className="table table-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="font-weight-bold">Code:</td>
                                                    <td>{inputs.code}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">From date:</td>
                                                    <td>{inputs.dateFrom}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Minimum Amount Per Year:</td>
                                                    <td>{inputs.minAmtPerYear}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Maximum Amount Per Year:</td>
                                                    <td>{inputs.maxAmtPerYear}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">CitizenShip:</td>
                                                    <td>{inputs.citizenShip}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Status:</td>
                                                    <td>{inputs.status}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">validate KUCCPS:</td>
                                                    <td>{inputs.kuccps}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Maximum Age:</td>
                                                    <td>{inputs.age}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br />
                                        <div
                                            style={{ display: "flex", "justify-content": "flex-end" }}
                                        >
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={HandleSubmit}>
                                        <div className="modal-body">
                                            <div className="row">
                                                <div className="col-md-6 md-offset-2">
                                                    <div className="form-group">
                                                        <label >Min Amt Per Year</label>

                                                        <input type="number"
                                                            className="form-control"
                                                            name="minAmtPerYear"
                                                            required
                                                            value={inputs.minAmtPerYear}
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Date From</label>
                                                        <input
                                                            className="form-control"
                                                            type="date"
                                                            name="dateFrom"
                                                            required
                                                            value={inputs.dateFrom}
                                                            onChange={handleInputChange}
                                                            className='form-control'
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Min Course Duration(Months)</label>

                                                        <input type="number"
                                                            required
                                                            className="form-control"
                                                            name="minCourseDuration"
                                                            value={inputs.minCourseDuration}
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Validate from KUCCPS</label>
                                                        <Select
                                                            name="kuccps"
                                                            className="form-group"
                                                            value={KUCCPSOptions.filter(
                                                                (option) => option.value === inputs.kuccps
                                                            )}
                                                            onChange={handleSelectChange}
                                                            options={KUCCPSOptions}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 md-offset-2">
                                                    <div className="form-group">
                                                        <label >Max Amt Per Year</label>
                                                        <input type="number"
                                                            required
                                                            className="form-control"
                                                            name="maxAmtPerYear"
                                                            value={inputs.maxAmtPerYear}
                                                            onChange={handleInputChange}
                                                        />

                                                    </div>
                                                    <div className="form-group">
                                                        <label >Citizen Ship</label>
                                                        <Select
                                                            name="citizenShip"
                                                            className="form-group"
                                                            value={CitizenShipOptions.filter(
                                                                (option) => option.value === inputs.citizenShip
                                                            )}
                                                            onChange={handleSelectChange}
                                                            options={CitizenShipOptions}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label>Status</label>
                                                        <Select
                                                            name="status"
                                                            className="form-group"
                                                            value={StatusOptions.filter(
                                                                (option) => option.value === inputs.status
                                                            )}
                                                            onChange={handleSelectChange}
                                                            options={StatusOptions}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Maximum Age</label>
                                                        <input type="number"
                                                            required
                                                            className="form-control"
                                                            name="age"
                                                            value={inputs.age}
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <a
                                                className="btn btn-white"
                                                data-dismiss="modal"
                                                onClick={handleCloseModal}
                                            >
                                                Close
                                             </a>
                                            {update ? (
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary"
                                                >
                                                    Update
                                                </button>
                                            ) : (
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary"
                                                >
                                                    Save
                                                </button>
                                            )}
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>

    );
};
export default CapitationCriteria;
